import React from 'react'
import { BANKING_BOTTOM_CONTENT, DIGITAL_COURSE_PAGE_2, DIGITAL_DETAILS_PAGE_2, DIGITAL_HERO_PAGE_2 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { DIGITAL_ACCORDIAN_2 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const DigitalPage_2 = () => {
  return (
    <div className='outlet-render'>
             <CourseAsideHero  {...DIGITAL_HERO_PAGE_2}/>
      <CoursesAside {...DIGITAL_COURSE_PAGE_2}/>
      <CourseCard {...DIGITAL_DETAILS_PAGE_2}/>
      <Accordian {...DIGITAL_ACCORDIAN_2}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DigitalPage_2